<script setup lang="ts">
defineProps({ blok: Object })

const { state } = useAppStore()

const charts = ref<any[]>([])

const activeChart = ref(0)

onMounted(async () => {
    await $fetch<any>(`/api/data/company`)
        .then((res) => {
            console.log(res)
            res.map((companyType: any) => {
                console.log(companyType)
                const ct = () => {
                    const sortedCompanies = companyType.companies.sort((a: any, b: any) => {
                        return b.scores[7].over_100 - a.scores[7].over_100
                    })

                    return {
                        name: companyType.company_type,
                        companies: sortedCompanies.map((company: any) => {
                            return company.name
                        }),
                        data: sortedCompanies.map((company: any) => {
                            return company.scores[7].over_100
                        }),
                    }
                }
                charts.value.push(ct())
            })
        })
})
</script>

<template>
    <section class="section relative">
        <div class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]" />
        <UiContainer max-width="max-w-3xl">
            <header class="global-header global-header--center">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <HomeRanks :blok="blok?.HomeCompaniesRanks" />
        <UiContainer
            max-width="max-w-3xl"
            class="mt-20"
        >
            <header class="global-header global-header--center">
                <StoryblokRichText :doc="blok?.comparative_header" />
            </header>
        </UiContainer>
        <UiContainer>
            <div>
                <div class="flex items-center justify-center gap-2 mb-6 max-[769px]:flex-col">
                    <div
                        v-for="(chart, index) in charts"
                        :key="chart.name"
                    >
                        <UButton
                            v-if="chart.name == 'Big Companies'"
                            :label="useCompanySizeName(state.sizes, 2)"
                            :variant="activeChart === index ? 'solid' : 'outline'"
                            @click="activeChart = index"
                        />
                        <UButton
                            v-if="chart.name == 'Small Companies'"
                            :label="useCompanySizeName(state.sizes, 1)"
                            :variant="activeChart === index ? 'solid' : 'outline'"
                            @click="activeChart = index"
                        />
                        <UButton
                            v-if="chart.name == 'Retailers'"
                            :label="useCompanySizeName(state.sizes, 3)"
                            :variant="activeChart === index ? 'solid' : 'outline'"
                            @click="activeChart = index"
                        />
                    </div>
                </div>
                <ClientOnly>
                    <div v-if="charts.length">
                        <div
                            v-for="(chart, index) in charts"
                            :key="chart.name"
                        >
                            <apex-charts
                                v-if="activeChart === index"
                                width="100%"
                                height="600"
                                :options="
                                    {
                                        chart: {
                                            type: 'bar',
                                            stackType: '100%',
                                            toolbar: {
                                                show: false,
                                            },
                                        },
                                        stroke: {
                                            show: false,
                                        },
                                        legend: {
                                            show: false,
                                        },
                                        dataLabels: {
                                            enabled: true,
                                            formatter: function (val: number) {
                                                return val.toFixed(0) + '%'
                                            },
                                            offsetY: -20,
                                            style: {
                                                fontSize: '12px',
                                                colors: ['#304758'],
                                            },
                                        },
                                        colors: [function({ value }: any) {
                                            return useScoreTreshold(value).default
                                        }],
                                        tooltip: {
                                            enabled: false,
                                        },
                                        plotOptions: {
                                            bar: {
                                                borderRadius: 0,
                                                dataLabels: {
                                                    position: 'top', // top, center, bottom
                                                },
                                            },
                                        },
                                        xaxis: {
                                            categories: chart.companies,
                                        },
                                    }"
                                :series="[{
                                    name: 'Overall',
                                    data: chart.data,
                                }]"
                            />
                        </div>
                    </div>
                    <div v-else>
                        <UProgress
                            animated
                            indeterminate
                        />
                    </div>
                </ClientOnly>
            </div>
        </UiContainer>
    </section>
</template>
